import React, { useMemo } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

import SnackbarController from "./SnackbarController";
import SnackbarsContainer from "./SnackbarsContainer";
import Context from "./Context";
import { DISPLAY_TIME } from "./constants";

export const Provider = ({ children, displayTime, containerElement }) => {
  const snackbarController = useMemo(() => new SnackbarController(), []);
  return (
    <Context.Provider value={{ snackbar: snackbarController }}>
      {children}
      {createPortal(
        <SnackbarsContainer
          displayTime={displayTime}
          addChangeListener={snackbarController.addChangeListener}
          removeChangeListener={snackbarController.removeChangeListener}
          remove={snackbarController.removeById}
        />,
        containerElement
      )}
    </Context.Provider>
  );
};

Provider.defaultProps = {
  displayTime: DISPLAY_TIME,
  containerElement: document.getElementById("root"),
};

Provider.propTypes = {
  children: PropTypes.node,
  containerElement: PropTypes.elementType,
  displayTime: PropTypes.number,
};
